module.exports = __webpack_public_path__ + "static/media/standing bilatral cartoon.72a3b438.png";